<template>
  <div class="ly-table">
    <div class="ly-sort ly-sort-his">
      <div class="sort-count">
        <p class="table-cell-all">
          {{ $t("messages.all") }} <span class="table-cell-count">{{ tableData.length }}</span
          >{{ $t("messages.unit") }}
        </p>
      </div>
    </div>
    <div class="table-body">
      <idc-list
        :tableHeader="tableHeader"
        :tableData="tableData"
        :notepad="notepad"
      >
        <template #apvSttusCd="{ scope }">
          <el-button type="primary" @click="visibleApprove(scope.row, scope)">{{
            $t("messages.approveComplete")
          }}</el-button>
        </template>
      </idc-list>
    </div>
  </div>
</template>

<script>
import IdcList from "@/components/common/IdcList";
export default {
  props: {
    loginUserId: {
      type: String,
      default: "",
    },
  },
  components: {
    IdcList,
  },
  computed: {
    tableHeader() {
      return [
        {
          prop: "apvSttusNm",
          label: "",
        },
        {
          prop: "srTitle",
          label: this.$t("messages.lblTitle"),
        },
        {
          prop: "wrkCtgHnglNm",
          label: this.$t("messages.lblWork"),
        },
        {
          prop: "wrkrNm",
          label: this.$t("messages.lblWorker"),
        },
        {
          prop: "wrkrEmail",
          label: this.$t("messages.lblEmail"),
        },
        {
          prop: "wrkrHp",
          label: this.$t("messages.lblContact"),
        },
        {
          prop: "apvSttusCd",
          columnType: "custom",
        },
      ];
    }
  },
  data() {
    return {
      notepad: true,
      tableData: [],
      serchData: {
        stepCd: '2868',
        tgtCtlogId: '1652084741069922',
        asgnrId: '',
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getApproveList();
    });
  },
  methods: {
    getApproveList() {
      this.serchData.asgnrId = this.loginUserId;

      this.tableData = [];
      this.$BIZ_SERVICE
        // .post(this.$API_URLS.Svc.getWflowTicktListByMsp, this.serchData)
        .post(this.$API_URLS.Svc.getWflowScndAprTicktList, this.serchData)
        .then((res) => {
          const { data } = res;
          console.log(data.resData)
          this.tableData = data.resData;
        })
        .catch((error) => {})
        .finally(() => {});
    },

    visibleApprove(row, index) {
      // if (!this.$isMobile()) return;
      console.log(row)

      /*
      var data = {
        exeWflowId: row.exeWflowId,
        stepCd: row.stepCd,
        ticktId: row.ticktId
      };

      if (row.ticktSttusCd == 2872) {
        this.$store.dispatch("wflowStore/postRepeipt", {
            ticktId: row.ticktId,
            noneAlert: true
          }).then(res => {
            this.$emit("visibleApprove", data);
          });
      }
      else {
        this.$emit("visibleApprove", data);
      }
      */
      this.$emit("visibleApprove", row);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .list-box {
    &-content:last-child {
      display: block;
      width: 100%;
      margin-left: 0;
      .title {
        display: none;
      }
      .content {
        width: 100%;
        margin-left: 0;
      }
      .el-button {
        width: 100%;
      }
    }
  }
}
</style>
